import { CircleCheckIcon, MailIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

import { useUpdateSetNotifications } from "@/hooks/updateSets/useUpdateSetNotifications";
import { mixpanelUtils } from "@/lib/mixpanel/mixpanel";
import { MIXPANEL_NOTIFICATION_SURFACES, MIXPANEL_SCREENS } from "@/lib/mixpanel/types";
import { cn } from "@/lib/utils";
import { NotificationType } from "@/types";

export const NotificationMarkReadButton = ({
  isCompact = false,
  isUnread,
  notificationId,
  notificationType,
  trackingSurface,
}: {
  isCompact?: boolean;
  isUnread: boolean;
  notificationId: number;
  notificationType: NotificationType;
  trackingSurface: MIXPANEL_NOTIFICATION_SURFACES;
}) => {
  const { mutate: updateNotifications } = useUpdateSetNotifications();

  const handleToggleReadState = () => {
    mixpanelUtils.trackButtonClick(
      isUnread ? "Mark notification read" : "Mark notification unread",
      MIXPANEL_SCREENS.NOTIFICATIONS,
      { notification_type: notificationType, surface: trackingSurface },
    );
    updateNotifications({
      notificationIds: [notificationId],
      markAsRead: isUnread,
    });
  };

  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            className={cn("h-8 w-8", isCompact && "h-7 w-7")}
            onClick={handleToggleReadState}
            size="icon"
            variant="ghost"
          >
            {isUnread ? (
              <CircleCheckIcon
                className={cn(
                  "h-4 w-4 text-slate-500",
                  isCompact && "h-3.5 w-3.5",
                )}
              />
            ) : (
              <MailIcon
                className={cn(
                  "h-4 w-4 text-slate-500",
                  isCompact && "h-3.5 w-3.5",
                )}
              />
            )}
          </Button>
        </TooltipTrigger>
        <TooltipContent className="z-[70]">
          {isUnread ? "Mark Read" : "Mark Unread"}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
